import { GridRowsProp, GridValidRowModel } from '@mui/x-data-grid';
import React, { useState, useEffect, useCallback } from 'react'
import PbGrid from '../../components/grid/grid.component';
import { PbColumns, ViewAction } from '../../components/grid/grid-constants';
import Page from '../../components/layout/page.component'
import { FileResponse, FileSource } from '../../components/interfaces/FileResponse';
import Loader from '../../components/loader/loader.component';
import { useCollectionService } from '../../services/collection.service';
import SheetItem, { AddButtonPosition } from '../../components/search/sheet-item.component';
import FileHelper from '../../helpers/filehelper';
import { toast } from 'react-toastify';
import { useRepertoireService } from '../../services/repertoire.service';

export default function CollectionList() {
    const [list, setList] = useState<GridRowsProp>()
    const [searching, setSearching] = useState(false);
    const [current, setCurrent] = useState<FileResponse>();

    const collectionService = useCollectionService();
    const repertoireService = useRepertoireService();

    const loadList = useCallback(async () => {
        if (list) return;
        setSearching(true);

        const { data } = await collectionService.getAll();

        if (data) {

            var rows: GridValidRowModel[] = [];

            (data as FileResponse[]).map(async (value, index) => {
                rows.push({
                    id: index,
                    title: value.address,
                    address: value.address,
                    extension: value.extension,
                    source: FileSource.Dropbox,
                    view: value.serverPath.endsWith('pdf') && !navigator.pdfViewerEnabled ? ViewAction.Download : ViewAction.View,
                    serverPath: value.serverPath,
                })
            })

            setList(rows)
        }

        setSearching(false);
    }, [collectionService, list])

    useEffect(() => {
        loadList();
    }, [loadList])

    const lineClick = (e: any) => {
        if (e.field === 'view')
            return onDownloadClick(e);
        if (e.field === 'repertoire')
            return onAddRepertoireClick(e);
    };

    const rowToFile = (row: any): FileResponse => ({
        address: row.address,
        extension: row.extension,
        serverPath: row.serverPath,
        source: row.source
    })

    const onAddRepertoireClick = async (e: any) => {
        await onAddRepertoireImageClick(rowToFile(e.row))
    }

    const onAddRepertoireImageClick = async (file: FileResponse) => {
        try {
            await repertoireService.add(file);

            toast.success(`Partitura '${file.address}' adicionada ao seu repertório!`);

        } catch {
            toast.error(`Não foi possivel adicionar a partitura '${file.address}' ao repertório.`)
        }
    }

    const onDownloadClick = async (e: any) => {
        setCurrent(undefined);

        if (e.row.extension === 'pdf' && !navigator.pdfViewerEnabled) {
            const file = await collectionService.getFile(e.row.serverPath);
            const titleWithExtension = e.row.serverPath.split("/").slice(-1).pop();
            FileHelper.TryDownload(titleWithExtension, file);
        }
        else
            setCurrent(rowToFile(e.row));
    }

    // Bring the preview into view, since it renders below the grid
    useEffect(() => {
        if (current)
            document.getElementById('sheet-preview')?.scrollIntoView({ block: 'start' });
    }, [current])

    return <Page
        eyebrow='Acervo'
        title='Lista do acervo'
        subtitle='Navegue por todas as partituras disponíveis. Visualize qualquer partitura ou adicione-a ao seu repertório.'>
        {searching && <Loader label='Carregando o acervo...' />}
        {list && <PbGrid columns={PbColumns} rows={list} onLineClick={e => lineClick(e)} />}
        {current && <div id='sheet-preview' style={{ marginTop: 24 }}>
            <SheetItem key={current.serverPath} item={current!} addButton={{ position: AddButtonPosition.High, onClick: onAddRepertoireImageClick }} />
        </div>}
    </Page>
}